import { Stack, Text, Title } from "@mantine/core"
import { Card, Grid } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import type { AdminResponses } from "@tfg/types/endpoints/admin"

import { PLAN_SETTING_CONFIGS } from "../../config"
import { PlanSettingSelect } from "./PlanSettingSelect"

type PlanSettingsSectionProps = {
  readonly organization: AdminResponses.OrganizationDetails
}

export function PlanSettingsSection({
  organization,
}: PlanSettingsSectionProps) {
  const { t } = useTranslation("admin")

  return (
    <Grid.Col span={{ base: 12, sm: 6 }}>
      <Card h="100%">
        <Stack gap="md">
          <Stack gap={4}>
            <Title order={2}>
              {t("featureAccess.subscriptionPlans.title", {
                defaultValue: "Subscription plans",
              })}
            </Title>
            <Text size="sm">
              {t("featureAccess.subscriptionPlans.description", {
                defaultValue:
                  "Manage legacy subscription plan settings for this organization.",
              })}
            </Text>
          </Stack>
          <Stack gap="xs">
            {PLAN_SETTING_CONFIGS.map((planSettingConfig) => (
              <PlanSettingSelect
                key={planSettingConfig.planKey}
                organization={organization}
                planSettingConfig={planSettingConfig}
                label={t(planSettingConfig.labelTranslationKey, {
                  defaultValue: planSettingConfig.labelTranslationKey,
                })}
              />
            ))}
          </Stack>
        </Stack>
      </Card>
    </Grid.Col>
  )
}

// t("plan.agecProductPagePlan.label")
// t("plan.agecProductPagePlan.starter")
// t("plan.agecProductPagePlan.essential")
// t("plan.agecProductPagePlan.advanced")
// t("plan.outputCustomizationPlan.label")
// t("plan.outputCustomizationPlan.essential")
// t("plan.outputCustomizationPlan.advanced")
// t("plan.outputCustomizationPlan.expert")
// t("plan.lcaCustomizationPlan.label")
// t("plan.lcaCustomizationPlan.advanced")
// t("plan.lcaCustomizationPlan.expert")
// t("plan.customFieldsPlan.label")
// t("plan.customFieldsPlan.advanced")
// t("plan.customFieldsPlan.expert")
// t("plan.certificatesPlan.label")
// t("plan.certificatesPlan.advanced")
// t("plan.certificatesPlan.expert")
// t("plan.zalandoPlan.label")
// t("plan.zalandoPlan.no")
// t("plan.zalandoPlan.yes")
// t("plan.rduePlan.label")
// t("plan.rduePlan.no")
// t("plan.rduePlan.yes")
